module.exports = __webpack_public_path__ + "assets/img/huancun.5c33cad6.gif";